import React from 'react';
import { useAuth, AuthProvider } from './hooks/useAuth';
import MainLayout from './features/core/MainLayout';
import LoginPage from './features/auth/LoginPage';
import { PageLoader } from './components/PageLoader';

const App = () => {
    const { user, isLoading } = useAuth();

    // While the initial authentication check is happening, show a loader.
    // This is crucial to prevent the app from trying to render with an
    // undefined user state, which can cause rendering loops.
    if (isLoading) {
        return <PageLoader />;
    }

    // After loading, if there is a user, show the main application layout.
    // Otherwise, show the login page.
    return user ? <MainLayout /> : <LoginPage />;
};

// The top-level component that wraps the entire application in the AuthProvider.
export default function MartechAIApp() {
    return (
        <AuthProvider>
            <App />
        </AuthProvider>
    );
}